import { themeAtom } from "../../shared/atoms";
import { useAtomValue } from "jotai";

export function ReactSelectStyling() {
  const theme = useAtomValue(themeAtom);

  const selectStyles = {
    control: (base: any, state: any) => ({
      ...base,
      backgroundColor: theme.technicalQuestionnaire.reactInputBg,
      borderColor: theme.technicalQuestionnaire.reactInputBorder,
      boxShadow: "none",
      "&:hover": {
        borderColor: theme.technicalQuestionnaire.reactInputBorder,
      },
    }),
    singleValue: (base: any) => ({ ...base, color: theme.uwhcAssistant.text }),
    option: (base: any, state: any) => ({
      ...base,
      backgroundColor: state.isSelected
        ? theme.crtDropInput.textDefault
        : state.isFocused
          ? theme.certDocumentIcon.tertiary
          : theme.balticQuestionnaire.reactDatePicker.selectedDayBg,
      color: theme.uwhcAssistant.text,
    }),
    indicatorSeparator: (base: any) => ({ ...base, backgroundColor: theme.technicalQuestionnaire.reactInputBorder }),
    dropdownIndicator: (base: any) => ({ ...base, color: theme.technicalQuestionnaire.reactInputBorder }),
    clearIndicator: (base: any) => ({ ...base, color: theme.technicalQuestionnaire.reactInputBorder }),

    menu: (base: any) => ({
      ...base,
      marginTop: 15,
      backgroundColor: theme.balticQuestionnaire.reactDatePicker.selectedDayBg,

      "--rs-scroll-thumb": theme.technicalQuestionnaire.reactInputBorder,
      "--rs-scroll-track": theme.technicalQuestionnaire.reactInputBg,
      "--rs-scroll-thumb-hover": theme.crtDropInput.textDefault,
    }),
  };
  return selectStyles;
}
